<template>
  <div class="trending-authors-grid flex flex-wrap gap-8">
    <div
      v-for="author in authors"
      class="flex flex-col gap-2 items-center w-16"
      :key="author.id"
    >
      <AuthorAvatar class="h-16 w-16" :author="author" :status="status" />
      <AuthorName
        class="author-name break-all"
        :author="author"
        :status="status"
      />
    </div>
  </div>
</template>

<script>
import AuthorAvatar from "@/templates/author/Avatar.vue";
import AuthorName from "@/templates/author/Name.vue";

export default {
  name: "TrendingAuthorsGrid",
  props: {
    authors: Array,
    status: String,
  },
  components: {
    AuthorAvatar,
    AuthorName,
  },
};
</script>
